import {
	hamburger
} from "./modules/hamburger";
import {
	modal
} from "./modules/modal";
import {
	pageTop
} from "./modules/pageTop";

hamburger();
modal();
pageTop();

const contactAc = document.querySelector(".js-contactAc");
const contactCont = document.querySelector(".js-contactCont");

contactAc.addEventListener("click", () => {
	if (contactCont.classList.contains("is-hide")) {
		contactAc.classList.add("is-active");
		contactCont.classList.remove("is-hide");
	} else {
		contactAc.classList.remove("is-active");
		contactCont.classList.add("is-hide");
	}
});